import { saveResponseAsBlob } from '@/helpers/save-blob'

export default
{
	methods:
	{
		async downloadContract(orderId)
		{
			try
			{
				const response = await this.$http.get
				(
					'/api/contracts/' + orderId,
					{
						params: { _: ( new Date ).getTime() },

						responseType: 'arraybuffer',
					}
				)

				saveResponseAsBlob(response)
			}
			catch(err)
			{
				this.sendErrorNotification('Unable to download contract')

				console.error(err)
			}
		},
	},
}